import api from "!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../node_modules/css-loader/dist/cjs.js??ref--9-1!../../node_modules/postcss-loader/dist/cjs.js??ref--9-2!../../node_modules/preact-cli/src/lib/webpack/proxy-loader.js??ref--6-0!./style.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};